






































































































































































































import Vue from "vue";
import * as types from "../../store/types";
import { rules, scrollToFirstInvalidElement } from "../../services/validation";
import { mapGetters, mapActions } from "vuex";

export default Vue.extend({
  name: "ApplicationStep3",

  props: {},

  data: () => {
    return {
      rules,
      formValue: {
        orgName: "",
        orgEmail: "",
        phone: "",
        website: "",
        operationAddressLine1: "",
        operationAddressLine2: "",
        operationAddressCity: "",
        operationAddressState: "",
        operationAddressZip: "",
        purposeOrMission: "",
        individualsServed: "",
        locatedInGreeneCounty: null,
        locatedInGreeneCountyExplain: "",
        outsideGreeneCounty: null,
        outsideGreeneCountyExplain: "",
        yearEstablished: "",
        monthEstablished: "",
        fein: "",
        duns: "",
        fulltime: "",
        parttime: "",
        volunteers: "",
        contactName: "",
        contactEmail: "",
        contactPhone: "",
        contactPosition: "",
      },
    };
  },

  methods: {
    ...mapActions({
      saveStep: types.SAVE_FORM_STEP,
    }),
    saveAndContinue() {
      this.saveStep({
        formFields: this.formValue,
      }).then(() => {
        // sometimes this if firing before the application-level validation, which reset the validation state, so we wait a little longer to be safe.
        setTimeout(() => {
          // @ts-ignore
          const isValid = this.$refs.form.validate();
          this.$emit("update-validity", 1, isValid);
          if (!isValid) {
            return scrollToFirstInvalidElement(this, this.$refs.form as Vue);
          }

          this.$emit("next-step");
        }, 500);
      });
    },
    copyMailingAddress() {
      [
        "AddressLine1",
        "AddressLine2",
        "AddressCity",
        "AddressState",
        "AddressZip",
      ].forEach(
        (fieldName) =>
          // @ts-ignore
          (this.formValue["operation" + fieldName] =
            // @ts-ignore
            this.formValue["mailing" + fieldName])
      );
    },
    save() {
      this.saveStep({
        formFields: this.formValue,
      });
    },
    updateValidity() {
      // @ts-ignore
      const formIsValid = this.$refs.form.validate();
      // @ts-ignore
      this.$refs.form.resetValidation();

      this.$emit("update-validity", 1, formIsValid);
    },
  },

  computed: {
    ...mapGetters({
      allFormValues: types.FORM_VALUES,
      saving: types.SAVING_FORM,
    }),
    showMonthField(): boolean {
      return (
        !!this.formValue.yearEstablished &&
        this.formValue.yearEstablished.trim() == "2020"
      );
    },
  },

  watch: {
    allFormValues: {
      immediate: true,
      handler() {
        // map this step's fields to Vuex's
        Object.keys(this.formValue).forEach(
          // @ts-ignore
          (key) => (this.formValue[key] = this.allFormValues[key])
        );

        setTimeout(() => this.updateValidity(), 50);
      },
    },
  },
});
